import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
const ReturnAndExchangePolicy = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.pageTitle}>{t("normal.returnExchange")}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: t("2esim.returnExchangePolicy.content", {
              brand: process.env.REACT_APP_PROD_NAME_DEV,
              cscontact: process.env.REACT_APP_LINE_CS_ACCOUNT,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default ReturnAndExchangePolicy;
